export const VIDEO_FEED_SOURCE = {
  TRENDING_FEED: "trending_feed",
};

export const INSTALL_REFERRER = {
  TOPBAR: "topbar",
  SIDEBAR: "sidebar",
  BOTTOMBAR: "bottombar",
  STATIC_INSTALL_BANNER: "static-banner-install",
  EXPLORE_NUDGE: "explore-nudge",
  CREATION_NUDGE: "creation-nudge",
  LIVE_NUDGE: "live-nudge",
  COMMENT_NUDGE: "comment-nudge",
  SHARESHEET: "sharesheet",
};

export const TENANT = {
  MOJ: "moj",
};

export const PHONE_MAX_LENGTH = 10;

export enum EXP_VARIANTS {
  VARIANT1 = "variant-1",
  VARIANT2 = "variant-2",
  VARIANT3 = "variant-3",
  CONTROL = "control",
}

export const VIDEO_FEED_BLOCK = {
  HARD_BLOCK: 10,
  BLOCK_VIDEO_FEED: "blockVideoFeed",
  UNIQUE_VIDEO_COUNTS: "uniqueVideoCounts",
  BENEFIT_LIST: [
    "Watch videos in the language of your choice",
    "Enjoy videos while saving your precious data",
    "Catch your favourite creators Live in action",
  ],
};

export enum FEED_BLOCK_NUDGE {
  SOFT = "soft-nudge",
  HARD = "hard-nudge-popup",
  HARD_FULLSCREEN = "hard-nudge-full-screen",
  FIRST_VIDEO_INSTALL = "first-video-install-nudge",
}

export const PAYMENTS_QUERY_PARAMS = {
  UUID: "uuid",
  PRODUCT_ID: "productId",
  AMOUNT: "amount",
  LANG: "lang",
  COINS: "coins",
};
export enum FEED_BLOCK_NUDGE_CTA {
  DOWNLOAD = "download",
  CLOSE = "close",
}

export const POP_UP_HEADINGS = {
  HARD_NUDGE_HEAD: "Interested in more videos",
  HARD_NUDGE_SUBHEAD: "Get the full experience of Moj get the below benefits",
  SHARE_SHEET_HEAD: "Share this content on the Moj app",
  SHARE_SHEET_SUBHEAD: "Get access to all the features",
  DEFAULT_HEAD: "Download Moj now!",
  DEFAULT_SUBHEAD: "To get access to all the features.",
};

export const QUERY_PARAMS = {
  REDIRECT: "redirect",
};

export const SENTRY_DSN =
  "https://db90da8ea8c2948d3b923f564d9b6209@o4506625433600000.ingest.sentry.io/4506625437466624";

export const SENTRY_OPTIONS = {
  attachStacktrace: true,
  // Will cause a deprecation warning, but the demise of `ignoreErrors` is still under discussion.
  // See: https://github.com/getsentry/raven-js/issues/73
  ignoreErrors: [
    // Random plugins/extensions
    "top.GLOBALS",
    // See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error.html
    "originalCreateNotification",
    "canvas.contentDocument",
    "MyApp_RemoveAllHighlights",
    "http://tt.epicplay.com",
    "Can't find variable: ZiteReader",
    "jigsaw is not defined",
    "ComboSearch is not defined",
    "http://loading.retry.widdit.com/",
    "atomicFindClose",
    // Facebook borked
    "fb_xd_fragment",
    // ISP "optimizing" proxy - `Cache-Control: no-transform` seems to reduce this. (thanks @acdha)
    // See http://stackoverflow.com/questions/4113268/how-to-stop-javascript-injection-from-vodafone-proxy
    "bmi_SafeAddOnload",
    "EBCallBackMessageReceived",
    // See http://toolbar.conduit.com/Developer/HtmlAndGadget/Methods/JSInjection.aspx
    "conduitPage",
    // Generic error code from errors outside the security sandbox
    // You can delete this if using raven.js > 1.0, which ignores these automatically.
    "Script error.",
    // Avast extension error
    "_avast_submit",
    "ECONNRESET",
  ],
  denyUrls: [
    // Google Adsense
    /pagead\/js/i,
    // Facebook flakiness
    /graph\.facebook\.com/i,
    // Facebook blocked
    /connect\.facebook\.net\/en_US\/all\.js/i,
    // Woopra flakiness
    /eatdifferent\.com\.woopra-ns\.com/i,
    /static\.woopra\.com\/js\/woopra\.js/i,
    // Chrome extensions
    /extensions\//i,
    /^chrome:\/\//i,
    // Other plugins
    /127\.0\.0\.1:4001\/isrunning/i, // Cacaoweb
    /webappstoolbarba\.texthelp\.com\//i,
    /metrics\.itunes\.apple\.com\.edgesuite\.net\//i,
  ],
};
